import { render, staticRenderFns } from "./requestRefund.vue?vue&type=template&id=3bef1376&scoped=true"
import script from "./requestRefund.vue?vue&type=script&lang=js"
export * from "./requestRefund.vue?vue&type=script&lang=js"
import style0 from "./requestRefund.vue?vue&type=style&index=0&id=3bef1376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef1376",
  null
  
)

export default component.exports